import frequencyPeakAlarmService from '../service/frequencyPeakAlarms'
const state = {
    alarms: [],
    alarmsLoading: false,
}

const actions = {
    getAlarms({ commit }, { pointId }) {
        commit('setLoading', true)
        return frequencyPeakAlarmService.getAlarms(pointId)
            .then(alarms => {
                commit('setAlarms', alarms)
                return alarms;
            }).finally(() => commit('setLoading', false))
    },
    saveAlarms({ commit }, {pointId, alarms}) {
        commit('setLoading', true)
        return frequencyPeakAlarmService.saveAlarms(pointId, alarms).then(alarms => {
            commit('setAlarms', alarms)
        }).catch(e => {
            console.log(e);
        }).finally(() => {
            commit('setLoading', false)
        })
    },

}
const mutations = {
    setAlarms(state, alarms) {
        state.alarms = alarms
    },
    setLoading(state, loading) {
        state.alarmsLoading = loading
    },
}
export default {
    namespaced: true,
    state,
    actions,
    mutations
}



